import { createRouter, createWebHistory } from 'vue-router'
import { getAuth } from 'firebase/auth'
import { auth } from '@/assets/firebase' // Assure-toi que l'instance Firebase est correctement importée

import Accueil from '../views/Accueil.vue'

const routes = [
  {
    path: '/',
    name: 'Accueil',
    component: Accueil
  },
  {
    path: '/Menu',
    name: 'Menu',
    component: () => import(/* webpackChunkName: "about" */ '../views/Menu.vue')
  },
  {
    path: '/plats',
    name: 'Plats',
    component: () => import('../views/Plats.vue')
  },
  {
    path: '/menus',
    name: 'Menus',
    component: () => import('../views/Menus.vue')
  },
  {
    path: '/California',
    name: 'California',
    component: () => import('../views/California.vue')
  },
  {
    path: '/favoris',
    name: 'Favoris',
    component: () => import('../views/Favoris.vue')
  },
  {
    path: '/connexion',
    name: 'Connexion',
    component: () => import('../views/Connexion.vue')
  },
  {
    path: '/espace-prive',
    name: 'EspacePrive',
    component: () => import('../views/EspacePrive.vue'),
    meta: { requiresAuth: true } // Indique que cette route nécessite une authentification
  },
  {
    path: '/mentionsLegales',
    name: 'MentionsLegales',
    component: () => import('../views/mentionsLegales.vue'),
  },
  //  {
  //    path: '/menu-claude',
  //   name: 'MenuClaude',
  //   component: () => import('../views/Menu.vue')
  //  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise(resolve => {
        setTimeout(() => resolve({ el: to.hash, behavior: 'smooth' }), 300)
      })
    }
    if (savedPosition) return savedPosition
    return { top: 0 }
  }
})


// Route guard pour protéger l'accès à l'espace privé
router.beforeEach((to, from, next) => {
  const user = auth.currentUser // Vérifie si un utilisateur est connecté
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Si l'utilisateur essaie d'accéder à une route nécessitant une authentification
    if (!user) {
      // Si l'utilisateur n'est pas connecté, redirige-le vers la page de connexion
      next({ name: 'Connexion' })
    } else {
      next() // L'utilisateur est authentifié, autorise l'accès
    }
  } else {
    next() // Les autres routes sont accessibles sans authentification
  }
})

// Ceinture-bretelles SEO : force le <meta name="robots"> sur les pages privées
// (/connexion, /mentionsLegales) au cas où Google lirait le DOM rendu plutôt
// que le header HTTP X-Robots-Tag envoyé par Firebase Hosting.
const NOINDEX_PATHS = ['/connexion', '/mentionsLegales']
function isNoIndexPath(path) {
  return NOINDEX_PATHS.some(p => path === p || path.startsWith(p + '/'))
}

router.beforeEach((to, from, next) => {
  let robotsTag = document.querySelector('meta[name="robots"]')
  if (!robotsTag) {
    robotsTag = document.createElement('meta')
    robotsTag.setAttribute('name', 'robots')
    document.head.appendChild(robotsTag)
  }
  robotsTag.setAttribute('content', isNoIndexPath(to.path) ? 'noindex, nofollow' : 'index, follow')
  next()
})

export default router
